




import Vue from 'vue';
import { Component, InjectReactive } from 'vue-property-decorator';

import { FeedTank, FeedTankSensorTypeEnum } from '@/api';

import FeedTankRadarChart from './components/FeedTankRadarChart.vue';
import FeedTankStrainChart from './components/FeedTankStrainChart.vue';

@Component({
	components: {
		FeedTankRadarChart,
		FeedTankStrainChart,
	},
})
export default class FeedTankCharts extends Vue {
	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank;

	public get isStrain(): boolean {
		return this.feedTank?.sensorType === FeedTankSensorTypeEnum.Strain;
	}

	public get chartComponent(): typeof Vue {
		return this.isStrain ? FeedTankStrainChart : FeedTankRadarChart;
	}
}
